import React from 'react';
import { ASC, List, ListHeader, ListPageLayout, SearchInput } from 'framework/list';
import { CreateButton } from 'framework/ui/ui-builder';
import useSkillBasedQueueService, {
  DISABLED_PERMISSION,
} from 'domain/gpo/skillBasedQueue/shared/skillBasedQueueService';
import { useSkillBasedQueueUrl } from 'domain/gpo/skillBasedQueue/skillBasedQueueRoute';
import SkillBasedQueueListLayout from 'domain/gpo/skillBasedQueue/List/SkillBasedQueueListLayout';

const SkillBasedQueueList = () => {
  const { search } = useSkillBasedQueueService();
  const { getCreateUrl } = useSkillBasedQueueUrl();

  return (
    <List getDataMethod={search} defaultSortOrder={ASC} defaultSortField="skillName">
      <ListPageLayout
        header={<ListHeader label="Skill Based Queues" icon="fa-coins" />}
        actions={[
          <CreateButton
            url={getCreateUrl()}
            label="Create Skill Based Queue"
            key="create-skill"
            permissionToCheck={DISABLED_PERMISSION}
          />,
        ]}
        search={<SearchInput label="skill name" />}
      >
        <SkillBasedQueueListLayout />
      </ListPageLayout>
    </List>
  );
};

export default SkillBasedQueueList;
